import React from 'react'
import { IonPage } from '@ionic/react'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'
import PreferredLanguageContent from './PreferredLanguage.content'

const PreferredLanguagePage: React.FC = () => {
  return (
    <IonPage id='PreferredLanguage'>
      <PCRHeader />
      <PreferredLanguageContent />
    </IonPage>
  )
}

export default PreferredLanguagePage
